const initSimplePreloader = (obj) => {
  Object.keys(obj).forEach(elem => obj[elem] = false)
  window.fsiPreloader = obj;
};
// registered Object Properties
//webfontsLoaded: false,
//sliderStarted: false
//iwaraLayoutComplete: false


const checkAndRemoveSimplePreloader = () => {
  const allTrue = Object.values(window.fsiPreloader).every(item => item);
  if (allTrue) {
    document.querySelector('body').style.opacity = '1';
  }
  // simple Version
};

export {
  initSimplePreloader,
  checkAndRemoveSimplePreloader
};